import type { DashboardParameterValue } from "../types";

/**
 * Substitute `{{ param_id }}` placeholders (same rules as {@link WidgetRenderer}).
 */
export function renderDashboardTemplate(
  value: string | undefined,
  params?: Record<string, DashboardParameterValue>,
): string | undefined {
  if (!value) return value;
  return value.replace(/\{\{\s*([a-zA-Z0-9_]+)\s*\}\}/g, (_match, key: string) => {
    const param = params?.[key];
    if (param === null || param === undefined || typeof param === "object") return "";
    return String(param);
  });
}
